import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getProductcode } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const ProductList = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  selectedProduct,
  index,
  disabled,
  projectId,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  console.log(`projectId`, projectId)

  const loadOptions = async projectId => {
    const data = await getProductcode(projectId)
    setIsLoading(false)
    const response = data?.data?.map(dta => {
      return {
        label:
          dta?.product_code &&
          ucfirst(
            dta.product_code + " - " + (dta.description ? dta.description : "")
          ),
        value: dta.id,
        ...dta,
      }
    })
    //   const addProductExists = response.some(
    //     (item) => item.name === "Add New"
    // );

    // if (!addProductExists) {
    //     response.unshift({
    //         value: "Add New",
    //         label: "Add New",
    //     });
    // }
    if (index == 0) {
      setFetchResponse(response)
    } else {
      const usedProduct = selectedProduct?.map(
        dt => dt?.product_id?.value != "" && dt?.product_id?.value
      )
      setFetchResponse(() => {
        const unUsedProduct = response.filter(item1 => {
          return !usedProduct?.some(item2 => item2 === item1.value)
        })
        return unUsedProduct
      })
    }
    // setFetchResponse(response)
  }
  useEffect(() => {
    loadOptions(projectId)
  }, [index, projectId])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
                <div className="css-placeholder">{placeholder || "Select"}</div>
              }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              isDisabled={disabled ? true : false}
              // menuPortalTarget={document.querySelector(
              //   target ? target : ".modal"
              // )}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          )
        }}
      />
    </div>
  )
}

export default ProductList
